import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

// components
import CheckboxRadio from 'common/CheckboxRadio';

const baseString = 'vra-include-data-multi-season';
const classString = classNames({
  [`${baseString}`]: true
});

const IncludeData = ({
  cropName,
  isIncluded,
  layerType,
  onToggleLayerInclusion,
  season
}) => {
  return (
    <CheckboxRadio
      className={classString}
      dataTestId={`${season}-${layerType}`}
      disabled={false}
      isChecked={isIncluded}
      onChange={() => onToggleLayerInclusion({
        isIncluded, season, cropName, layerType, year: season.substr(0,4)
      })}
      type='checkbox'
    />
  );
};

IncludeData.propTypes = {
  cropName: propTypes.string,
  isIncluded: propTypes.bool.isRequired,
  layerType: propTypes.string.isRequired,
  onToggleLayerInclusion: propTypes.func.isRequired,
  season: propTypes.string.isRequired
};

export default IncludeData;
